import * as React from 'react';

import { Pressable, View, WBRadio, WBText } from '@/core';
import styles from './style';
import { DeskType } from '../../model';

interface Props {
	desk: DeskType;
	onDeskSelect: (id: number) => void;
	selectedDesk: number;
}

export const DeskLabel: React.FC<Props> = ({ desk, onDeskSelect, selectedDesk }) => {
	return (
		<Pressable key={`label-${desk.id}`} onPress={() => onDeskSelect(desk.id)}>
			<View style={[styles.label, { opacity: !selectedDesk || selectedDesk === desk.id ? 1 : 0.5 }]}>
				<WBRadio checked={selectedDesk === desk.id} onChange={() => onDeskSelect(desk.id)}></WBRadio>
				<WBText style={styles.labelText}>{desk.name}</WBText>
			</View>
		</Pressable>
	);
};
